import type { ReactNode } from "react";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import i18n from "@/i18n";
import { AuthProvider } from "@/features/auth/context/AuthContext";
import { BulkCampaignProvider } from "@/features/bulk-messaging/context/BulkCampaignContext";

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <BulkCampaignProvider>{children}</BulkCampaignProvider>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}
